import React from "react";

import PropTypes from "prop-types";

import S from "./styles";

function List({
  height,
  onChange,
  onShowSizeChange,
  pagination,
  ...propsList
}) {
  return (
    <S.List
      height={height}
      size="small"
      pagination={{
        pageSizeOptions: ["10", "20", "50", "100"],
        showTotal: (count, range) =>
          `${range[0]}-${range[1]} de ${count} itens`,
        onChange: (page, pageSize) => {
          return onChange(page, pageSize);
        },
        onShowSizeChange: (current, size) => {
          return onShowSizeChange(current, size);
        },
        showSizeChanger: true,
        hideOnSinglePage: true,
        ...pagination,
      }}
      {...propsList}
    />
  );
}

List.Item = S.List.Item;

List.defaultProps = {
  height: "auto",
};

List.propTypes = {
  height: PropTypes.string,
};

export default List;
